import React from 'react';
import '../UserCommonComponent/CommonComponent.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Logo from '../../assets/ManikbagLogo.png';
import { Link } from 'react-router-dom';




const UserMasterFooter = () => {

  return (
    <div className='m-0'>
   <Container fluid className='footer-container p-md-3 m-0 px-md-3' style={{boxSizing:"border-box"}}>
      <Row className='py-1'>
        <Col sm={12} md={6} className='text-white text-center  py-1'>
        <div >
          <img src={Logo}  alt="MANIKBAG LOGO" width={100} height={100}/>
        </div> 
        <div className='text-center pt-3' >
            <h4 className='fw-bolder'>MANIKBAG DIGAMBAR JAIN BOARDING</h4>
            <h6 className='fw-bolder'>18TH JAIN VADHU VAR PARICHAYA MELAVA</h6>
        </div>
        </Col>
        <Col sm={12} md={6} className='text-center py-1' style={{lineHeight:"40px"}}>
            <div className='text-start ps-5'>
            <h4  style={{color: "rgb(233, 224, 227)", paddingBottom:"15px"}}><b>Contact</b></h4>
            </div>
            <div className='text-start ps-5'>
            <a href="mailto:jainboardingsangli@gmail.com" style={{textDecoration: "none", color: "white", color: "white" }}>
              <i style={{ paddingRight: "10px", color:"white"}} className="fa-solid fa-envelope text-light"></i>   
               <span>Manikbag Digambar Jain Boarding, Belagavi.</span>
              </a> <br/>
            <a href="mailto:jainboardingsangli@gmail.com" style={{textDecoration: "none", color: "white", color: "white" }}>
              <i style={{ paddingRight: "10px", color:"white"}} className="fa-solid fa-envelope text-light"></i>   
              Address : <span> Mallikarjun Nagar, Kapileswar Colony, Shahapur, Belagavi, Karnataka 590016</span>
              </a> <br/>
            <a href="mailto:jainboardingsangli@gmail.com" style={{textDecoration: "none", color: "white", color: "white" }}>
              <i style={{ paddingRight: "10px", color:"white"}} className="fa-solid fa-envelope text-light"></i>   
              Email : <span>jainboardingbelagavi@gmail.com</span>
              </a>
              <br/>
              <a href="tel:02332623206" style={{ textDecoration: "none", color: "white", color: "white" }}>
              <i style={{ paddingRight: "10px",color:"white" }} className="fa-solid fa-phone text-light"></i> 
              Contact: 7022691008 , 9480448108
            </a><br/>
            </div>
        </Col>
      </Row>
      <Row>
        <Col>
        <div className='text-center' style={{display:"flex", justifyContent:"center", color:"white", paddingTop:"10px", borderTop:"1px solid ",paddingBottom:"0px"}}>
            &copy; MANIKBAG DIGAMBAR JAIN BOARDING | Managed By : TechnoAarv Solution
        </div>
        </Col>
      </Row>
    </Container>
    </div>
  )
}

export default UserMasterFooter